<template>
<div v-if="userName" class="user-poptip">
  <Poptip @on-popper-show="open">
    <span v-if="userName.length>5" class="user-name dashed" >{{userName|subString(4)}}</span>
    <span v-else class="user-name dashed">{{userName}}</span>
    <div slot="content" class="poptip-box">
      <div class="user-box" @click="openForm">
        <i class="dian red"></i>
        <span class="user-name line">{{userName}}</span>
      </div>
      <div class="table-text-box">
        <div class="item">
          <label>工号：</label>
          <div class="text">{{formData.staffNo}}</div>
        </div>
        <div class="item" v-if="formData.organizationName">
          <label>所属机构：</label>
          <Tooltip class="text" :content="formData.organizationName" v-if="formData.organizationName.length>7">{{formData.organizationName|subString(7)}}</Tooltip>
          <div class="text" v-else>{{formData.organizationName}}</div>
        </div>
        <div class="item">
          <label>入职日期：</label>
          <div class="text">{{formData.entryTime?formData.entryTime.substring(0,10):""}}</div>
        </div>
        <div class="item">
          <label>当前职级：</label>
          <div class="text">{{formData.rankName}}</div>
        </div>
        <div class="item">
          <label>联系电话：</label>
          <div class="text" v-if="eyeShow">{{formData.mobile}}</div>
          <div class="text" v-else>{{formData.mobile1}}</div>
          <i class="iconfont iconxianshi eye-icon" v-if="eyeShow" @click="openEye"></i>
          <i class="iconfont iconyincang eye-icon" v-else @click="openEye"></i>
        </div>
      </div>
      <div class="table-title">职级变更记录</div>
      <Table :columns="columns1" :data="tableData"></Table>
      <!-- <div class="table-title">推荐链</div>
      <Table :columns="columns2" :data="tableData"></Table> -->
    </div>
  </Poptip>
</div>

</template>

<script>
import tooltip from '@/components/commons/tooltip'
import {common} from "@/api/mixins";
export default {
  mixins:[common],
  components: {tooltip},
  props: {
    id:null,
    userName:null
  },
  data() {
    return {
      formData:{},
      tableData:[],
      loading: false,
      eyeShow: false,
      columns1:[
        {
          title: "生效时间",
          key: "contractBeginDate",
          align: "center",
          minWidth: 160,
          render(h, params) {
            const date = params.row.updateTime?params.row.updateTime.substring(0,10):'';
            return <span>{date}</span>;
          },
        },
        // {
        //   title: "基本法",
        //   key: "baseName",
        //   align: "center",
        //   render(h, params) {
        //     const text = params.row.baseName||'-';
        //     return <span>{text}</span>;
        //   },
        //   tooltip:true
        // },
        {
          title: "职级",
          key: "newRankName",
          align: "center",
          tooltip:true
        },
      ],
      columns2:[
        {
          title: "姓名",
          key: "contractBeginDate",
          align: "center",
        },
        {
          title: "入职时间",
          key: "contractBeginDate",
          align: "center",
          minWidth: 160,
        },
        {
          title: "推荐人",
          key: "contractBeginDate",
          align: "center",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    open(){
      this.loading = true;
      Promise.all([
        this.getUserData(),
        this.getList(),
      ]).then(()=>{
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      });
    },
    // 用户数据
    getUserData(){
      return this.$http({
        url: '/buz/userBase/read/detail',
        type: 'get',
        data: {
          id:this.id,
        },
      }).then((res) => {
        this.formData = res.data;
      })
    },
    // 职级记录
    getList(){
      return this.$http({
        url: '/buz/userPromotionRecord/read/list',
        type: 'POST',
        data: {
          userId:this.id,
          pageNo:"1",
          pageSize:"99",
          status:"1",
        },
      }).then((res) => {
        this.tableData = res.data;
      })
    },
    // 打开表单
    openForm(){
      this.$router.push({
        path:"/orgManage/salesmanForm/"+this.formData.id,
        query:{
          groupId:this.formData.groupId,
          userId:this.formData.id,
        }
      })
    },
    openEye(){
      if(this.eyeShow==false){
        this.descrypt({
          query:this.formData.id,
          operationFunction:1,
          operationType:2,
        },this.formData,'mobile').then(()=>{
          this.eyeShow=true
        })
      }else{
        this.eyeShow=false
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.user-poptip /deep/ .poptip-box {
  width: 340px;
  font-size: 12px;
  .eye-icon {
    font-size: 16px;
    line-height: 1;
    margin-left: 4px;
    cursor: pointer;
  }
  .table-text-box {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    .item {
      width: 50%;
      display: flex;
      align-items: center;
      padding-top: 6px;
      padding-right: 10px;
      label {
        color: #515C6F;
        margin-bottom: auto;
      }
      .text {
        color: #3C464F;
        white-space: normal;
        margin-bottom: auto;
      }
    }
  }
  .table-title {
    padding: 8px 0;
    text-align: left;
    color: #3C464F;
    font-size: 12px;
  }
  tr.ivu-table-row-hover td {
    background-color: #fff;
  }
  .ivu-table{
    margin-bottom: 0;
  }
  .ivu-table th, .ivu-table td {
    height: 26px;
    padding: 0;
    font-size: 12px;
    font-weight: initial;
    background-color: #fff;
  }
  .user-box {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #236DFF;
    height: 22px;
    padding-left: 0;
    justify-content: left;
    &.text {
      color: #515C6F;
    }
    .user-name {
      cursor: pointer;
      &.dashed {
        border-bottom: 1px dashed #236DFF;
      }
      &.line {
        border-bottom: 1px solid #236DFF;
      }
    }
    i {
      color: #BABABA;
      font-size: 12px;
    }
    .iconduichang {
      margin-left: 4px;
    }
  }
  
}
</style>